import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from './api.service';
import { ModelService } from './model/model.service'; 

import { CookieService }  from 'angular2-cookie/services/cookies.service';
import { PaginationModule } from 'ng2-bs-pagination';
// import { ToastyModule } from 'ng2-toasty'; // version 2.1.0

// // SHARED
import { AuthService }          from './auth.service';
import { AuthGuard }            from './auth-gard.service';
import { UtilsService }         from './utils.service';
import { MetaService } from './meta.service';
import { ContentService }       from './content.service'
import { DataService }          from './data.service';
import { LanguageSelectorComponent }  from './language-selector.component';
import { LanguageRoutingComponent }  from './language-routing.component';
import { LoadingIndicator } from './loading-indicator';
import { ElasticSearchService } from './search-elasticsearch.service';
import { SearchFilterComponent } from './search-filter.component';
import { SearchableContentsComponent } from './searchable-contents.component';
import { SearchComponent } from './search.component';
import { SearchService } from './search.service';
import { NotificationService} from './notification.service';
import { SearchAutocompleteComponent } from './search-autocomplete.component';
import { MapToIterable } from './map-to-iterable.pipe';
import { ReplacePipe } from './replace.pipe';
import { TruncatePipe } from './truncate.pipe';
import { Date2YearPipe } from './date2year.pipe';
import { IntlPipe } from './intl.pipe';
import { NameResolverPipe } from './name-resolver.pipe';
import { JoinPipe } from './join.pipe';
import { NumberFormat } from './number-format.pipe';
import { IntlService } from './intl.service';
import { ConfigService } from './config.service';
// TEST
import { TestComponent } from './test.component';

const MODULES = [
  // Do NOT include UniversalModule, HttpModule, or JsonpModule here!
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  PaginationModule,
  // ToastyModule 
];

const PIPES = [
  // put pipes here
  MapToIterable, ReplacePipe, TruncatePipe, Date2YearPipe, IntlPipe, NameResolverPipe, JoinPipe, NumberFormat
];

const COMPONENTS = [
  // put shared components here
  LanguageRoutingComponent, LanguageSelectorComponent,
  SearchFilterComponent, SearchableContentsComponent, SearchComponent, SearchAutocompleteComponent,
  LoadingIndicator,
  // test 
  TestComponent
];

const PROVIDERS = [
  ModelService,
  ApiService,
  CookieService,
  AuthService,
  AuthGuard,
  ContentService,
  DataService,
  UtilsService,
  SearchService,
  ElasticSearchService,
  MetaService,
  NotificationService,
  IntlService,
  ConfigService
]

@NgModule({
  imports: [
    ...MODULES
  ],
  declarations: [
    ...PIPES,
    ...COMPONENTS
  ],
  exports: [
    ...MODULES,
    ...PIPES,
    ...COMPONENTS
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        ...PROVIDERS
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/shared.module.ts